import Phaser from 'phaser';

export default class Emitter extends Phaser.GameObjects.Container {
  /**
     * 
     * @param {Phaser.Scene} scene 
     */
  constructor(scene, size) {
    super(scene);

    this.size = size;
    this.particleCount = 0;

    this.time = Date.now();
  }

  emit(emitterHandler, numParticles) {
    this.numParticles = numParticles;

    switch (emitterHandler) {
      case 'explosion':
        this.scene.events.on(Phaser.Scenes.Events.PRE_UPDATE, this.explosion, this);
        this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this.explosion, this));
        break;
    }
  }

  explosion() {
    const now = Date.now();
    const elapsed = now - this.time;
    this.time = now;

    const color = 0xffffff;
    const alpha = 1;

    if (this.particleCount < this.numParticles) {
      this.createCircle(color, alpha);
      this.createCircle(color, alpha);
      this.createCircle(color, alpha);
      this.createCircle(color, alpha);
      this.createCircle(color, alpha);
      this.createCircle(color, alpha);
      this.createCircle(color, alpha);
      this.createCircle(color, alpha);
      this.createCircle(color, alpha);
      this.createCircle(color, alpha);
      this.particleCount++;
    }

    for (let i = 0; i < this.length; i++) {
      const circle = this.getAt(i);

      circle.time += elapsed / 1000;
      circle.x += circle.speedX;
      circle.y += circle.speedY;

      if (circle.y > this.scene.scale.height + this.size || circle.time > 1) {
        circle.destroy();

        if (this.length === 0) {
          this.removeAllListeners();
        }
        i--;
      }
    }
  }

  createCircle(color, alpha) {
    const size = Phaser.Math.Between(2, 5);
    const circle = this.scene.add.circle(0, 0, size, color);

    const factor = 4;

    circle.speedX = -1 * factor + Math.random() * 2 * factor;
    circle.speedY = -1 * factor + Math.random() * 2 * factor;
    circle.time = 0;
    circle.alpha = alpha;

    this.add(circle);
  }
}